<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'main.addRewards' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content>
    <div class="rewards-content">
      <div class="rewards-select">
        <mat-form-field>
          <mat-select placeholder="{{'main.eventType' | translate}}" [(value)]="selected">
            @for (event of eventCategories; track event) {
              <mat-option [value]="event.value" [style.color]="event.color">
                <span style="font-weight: bold">{{event.label}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="rewards-select">
        <mat-form-field>
          <mat-select placeholder="{{'user.targetGroup' | translate}}" [(value)]="selectedTg" required>
            @for (tg of targetGroups; track tg) {
              <mat-option [value]="tg.id">
                <span style="font-weight: bold">{{tg.ageMask}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="rewards-input">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Credits" value="0" type="number" [(ngModel)]="numberItem">
        </mat-form-field>
      </div>
      <div class="full-width">
        <mat-form-field class="full-width">
          <input matInput placeholder="Comment" value="" type="text" [(ngModel)]="comment">
        </mat-form-field>
      </div>
    </div>
    <div class="rewards-button">
      <button mat-raised-button
        class="add-product-button mat-white-bg my-12 mt-sm-0" (click)="add()">
        <span>{{'event.add_new_reward' | translate}}</span>
      </button>
    </div>
  </div>
</div>
